import { render, staticRenderFns } from "./LayoutMode.vue?vue&type=template&id=56c0f921&scoped=true"
import script from "./LayoutMode.vue?vue&type=script&lang=js"
export * from "./LayoutMode.vue?vue&type=script&lang=js"
import style0 from "./LayoutMode.vue?vue&type=style&index=0&id=56c0f921&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c0f921",
  null
  
)

export default component.exports